import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useApiClient } from '@/api/clients/useApiClient.util.ts';
import { TaskStatusDto } from '@/api/generated';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';

type Req = {
  status: TaskStatusDto;
  taskId: string;
};

type Return = {
  isUpdating: boolean;
  updateTaskStatus: (req: Req) => Promise<void>;
};

export const useUpdateTaskStatus = (): Return => {
  const { tasksApi } = useApiClient();
  const queryClient = useQueryClient();
  const { isPending, mutateAsync } = useMutation<void, AxiosError, Req>({
    meta: { disableSuccessAlert: true },
    mutationFn: async req => {
      await tasksApi.updateTaskStatus(req.taskId, { status: req.status });
    },
    onSuccess: async (_data, req) => {
      await queryClient.invalidateQueries({ queryKey: [QueryKeyEnum.TASKS.DETAILS, req.taskId] });
    },
  });

  return {
    isUpdating: isPending,
    updateTaskStatus: mutateAsync,
  };
};
